export default {
  GET_DOBY: "/api/v1/doby",
  GET_DOBY_LIST: "/api/v1/doby/list",
  GET_DOBY_DETAIL_DEPRECATED: "/api/v1/doby/detail",
  GET_DOBY_DETAIL: "/api/v1/doby/detail",
  GET_DOBY_FILES: "/api/v1/doby/files",
  GET_DOBY_REGISTERED_CARD: "/api/v1/doby/registered-card",

  POST_DOBY_SAVE_FILE: "/api/v1/doby/files",

  POST_DOBY_CANCEL: "/api/v1/doby/cancel",
  POST_DOBY_ENTER_DETAIL: "/api/v1/doby/enter-detail",
  POST_DOBY_CONVERT_TO_MONTHLY: "/api/v1/doby/convert-to-monthly",

  GET_DOBY_OWNER_BANK_CHECK: "/api/v1/order/bank-account",
};
